<template>
  <div class="chat-color-picker mt-3">
    <ColorPicker
      :value="draftHex"
      @update:value="draftHex = $event"
    />
    <div class="d-flex justify-end mt-3">
      <v-btn
        color="primary"
        rounded="lg"
        size="small"
        :disabled="busy || !draftHex"
        @click="emit('apply', { formKey, hex: draftHex })"
      >
        {{ t('onboarding.wizard.chat-widgets.apply-color') }}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import ColorPicker from '@/components/ColorPicker.vue'

const props = defineProps<{
  formKey: string
  initialHex?: string
  busy?: boolean
}>()

const emit = defineEmits<{
  apply: [payload: { formKey: string; hex: string }]
}>()

const { t } = useI18n()
const draftHex = ref(props.initialHex || '#000000')
</script>

<style scoped>
.chat-color-picker :deep(.v-color-picker) {
  max-width: 100%;
}
</style>
